<template>
  <div class="asset-info">
    <div class="leftBack" @click="goBack">
      <van-icon name="arrow-left" />
    </div>

    <div class="asset-content">
      <h3 class="asset-list">扫描资产编码</h3>
      <div class="asset-name">
        <h4>{{ name }}</h4>
        <p>{{ code }}</p>
      </div>
      <!-- <h3 class="asset-list content">资产盘点列表</h3> -->
      <van-cell-group inset class="asset-list content">
        <van-field v-model="assetName" label="资产盘点列表" placeholder="请输入资产名称" clearable @clear="onClearAsset"
          @input="debouncedFilterAsset" />
      </van-cell-group>
      <van-tabs v-model:active="current" animated color="rgb(26 121 160)" @click-tab="assetToggle">
        <van-tab title="未盘点" name="0">
          <div class="assets-main todo" v-for="item in listInfo" :key="item.id" @click="handleAssetListA(item, 1)">
            <p v-if="item['propertyBasicInfo.name']">
              名称：<span v-html="highlight(item['propertyBasicInfo.name'])"></span>
            </p>
            <p v-if="item['propertyBasicInfo.code']">
              编码：<span v-html="highlight(item['propertyBasicInfo.code'])"></span>
            </p>
            <p v-if="item['propertyBasicInfo.belongTypeDic.name']">
              类型：<span v-html="highlight(item['propertyBasicInfo.belongTypeDic.name'])"></span>
            </p>
            <p v-if="item['propertyBasicInfo.specificationInfo']">
              规格型号：<span v-html="highlight(item['propertyBasicInfo.specificationInfo'])"></span>
            </p>
            <p v-if="item['propertyBasicInfo.principal']">
              车牌号：<span v-html="highlight(item['propertyBasicInfo.principal'])"></span>
            </p>
            <p>
              一级部门：<span v-html="displayHighlight(item['propertyBasicInfo.firstDeptName'])"></span>
            </p>
            <p>
              二级部门：<span v-html="displayHighlight(item['propertyBasicInfo.secondDeptName'])"></span>
            </p>
            <p>
              三级部门：<span v-html="displayHighlight(item['propertyBasicInfo.deptName'])"></span>
            </p>
            <p>
              {{ getUserLabel(item) }}<span v-html="displayHighlight(getUserValue(item))"></span>
            </p>
            <p v-if="item['startTime']">
              开始使用日期：<span v-html="highlight(item['startTime'])"></span>
            </p>
          </div>
          <van-divider v-if="!listInfo.length" class="empty-placeholder">暂无未盘点数据</van-divider>
        </van-tab>
        <van-tab title="已盘点" name="1">
          <div class="assets-main done" v-for="item in listInfo" :key="item.id" @click="handleAssetListA(item, 2)">
            <p v-if="item['propertyBasicInfo.name']">资产名称：<span
                v-html="highlight(item['propertyBasicInfo.name'])"></span></p>
            <p v-if="item['propertyBasicInfo.code']">资产编码：<span
                v-html="highlight(item['propertyBasicInfo.code'])"></span></p>
            <p v-if="item['propertyBasicInfo.belongTypeDic.name']">资产类型：<span
                v-html="highlight(item['propertyBasicInfo.belongTypeDic.name'])"></span></p>
            <p v-if="item['propertyBasicInfo.specificationInfo']">规格型号：<span
                v-html="highlight(item['propertyBasicInfo.specificationInfo'])"></span></p>
            <p v-if="item['propertyBasicInfo.principal']">车牌号：<span
                v-html="highlight(item['propertyBasicInfo.principal'])"></span></p>
            <p>一级部门：<span v-html="displayHighlight(item['propertyBasicInfo.firstDeptName'])"></span></p>
            <p>二级部门：<span v-html="displayHighlight(item['propertyBasicInfo.secondDeptName'])"></span></p>
            <p>三级部门：<span v-html="displayHighlight(item['propertyBasicInfo.deptName'])"></span></p>
            <p>{{ getUserLabel(item) }}<span v-html="displayHighlight(getUserValue(item))"></span></p>
            <p v-if="item['startTime']">开始使用日期：<span v-html="highlight(item['startTime'])"></span></p>
          </div>
          <van-divider v-if="!listInfo.length" class="empty-placeholder">暂无已盘点数据</van-divider>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: "ReceiveCheck",

  data() {
    return {
      current: 0,
      id: "",
      listInfo: [],
      name: "",
      code: "",
      TODO: "CMS_CHECK_STATUS_TO_CHECK", //未盘点
      DONE: "CMS_CHECK_STATUS_HAD_CHECK", //已盘点
      assetName: "",
      baseListInfo: [],
      searchableFields: [
        "propertyBasicInfo.name",
        "propertyBasicInfo.code",
        "propertyBasicInfo.belongTypeDic.name",
        "propertyBasicInfo.specificationInfo",
        "propertyBasicInfo.principal",
        "propertyBasicInfo.firstDeptName",
        "propertyBasicInfo.secondDeptName",
        "propertyBasicInfo.deptName",
        "propertyBasicInfo.userUnit",
        "propertyBasicInfo.unitPeople",
        "startTime",
      ],
    };
  },
  created() { },
  mounted() {
    // console.log(this.current, 'activated');
    // this.current = localStorage.getItem("cms-current") || 0;
    // this.name = this.$route.query.name;
    // this.code = this.$route.query.code;
    // // this.assetToggle();
    // this.getlistInfo(this.current < 1 ? this.TODO : this.DONE);
  },
  activated() {
    const needRefresh = localStorage.getItem("cms-refresh-on-back") === "1";
    if (needRefresh) {
      localStorage.removeItem("cms-refresh-on-back");
      this.current = localStorage.getItem("cms-current") || 0;
      this.name = this.$route.query.name;
      this.code = this.$route.query.code;
      this.getlistInfo(this.current < 1 ? this.TODO : this.DONE);
      return;
    }
    if (this.$route.query.id != this.id) {
      this.current = localStorage.getItem("cms-current") || 0;
      this.name = this.$route.query.name;
      this.code = this.$route.query.code;
      this.getlistInfo(this.current < 1 ? this.TODO : this.DONE);
    }
  },
  methods: {
    debouncedFilterAsset: debounce(function () {
      this.filterAsset();
    }, 300),
    onClearAsset() {
      this.assetName = "";
      this.listInfo = this.baseListInfo;
    },
    escapeRegExp(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    highlight(text) {
      if (!this.assetName) {
        return String(text);
      }
      var pattern = new RegExp(this.escapeRegExp(this.assetName), 'ig');
      return String(text).replace(pattern, function (m) { return '<span class="highlight">' + m + '</span>'; });
    },
    displayHighlight(text) {
      var str = text === null || text === undefined ? '' : String(text);
      if (str.trim() === '') {
        return '-';
      }
      return this.highlight(str);
    },
    getUserLabel(item) {
      var lease = item['propertyBasicInfo.userUnit'];
      var own = item['propertyBasicInfo.unitPeople'];
      if (lease && String(lease).trim() !== '') {
        return '设备使用人：';
      }
      if (own && String(own).trim() !== '') {
        return '设备使用人：';
      }
      return '设备使用人：';
    },
    getUserValue(item) {
      var lease = item['propertyBasicInfo.userUnit'];
      var own = item['propertyBasicInfo.unitPeople'];
      if (lease && String(lease).trim() !== '') {
        return String(lease);
      }
      if (own && String(own).trim() !== '') {
        return String(own);
      }
      return '';
    },
    shouldExcludeKey(key) {
      return this.excludedKeys.includes(key) || key.startsWith("wareHouse.id");
    },
    filterAsset() {
      if (this.assetName.trim() === "") {
        this.listInfo = this.baseListInfo;
      } else {
        this.listInfo = this.baseListInfo.filter((asset) => {
          return this.searchableFields.some((field) => {
            if (field in asset) {
              return String(asset[field])
                .toLowerCase()
                .includes(this.assetName.toLowerCase());
            }
            return false;
          });
        });
      }
    },
    getlistInfo(type) {
      this.id = this.$route.query.id;
      this.baseListInfo.length = 0
      this.listInfo.length = 0
      let that = this;
      let params = {
        "checkOrder.id": this.id,
        "statusDic.code": type,
      };
      var option1 = {
        portName: "cms.property.zlbasicInfo.getList",
        data: params,
        successCallback(data) {
          that.baseListInfo = data.entities;
          that.listInfo = data.entities;
          that.filterAsset();
        },
      };

      this.$sapi.callPort(option1);
    },
    handleAssetListA(item, index) {
      this.$router.push({
        path: "receiveCheckInfo",
        query: {
          item: JSON.stringify(item),
          type: index,
        },
      });
    },
    assetToggle({ name }) {
      localStorage.setItem("cms-current", name);
      this.getlistInfo(name < 1 ? this.TODO : this.DONE);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.empty-placeholder {
  margin-top: 10rem;
}

.asset-content {
  padding: 1rem;
}

.asset-info {
  width: 100vw;
  height: calc(100% - 88px);
  background: #ffffff;
  position: relative;
}

.leftBack {
  position: fixed;
  top: 11px;
  left: 10px;
  z-index: 99999;
}

.asset-name {
  color: #333;
  margin-left: 8px;
  border-left: 1px solid #ccc;
  padding-left: 15px;
}

.asset-name h4 {
  font-weight: 300;
  font-size: 3rem;
  margin: 0;
}

.asset-name p {
  font-size: 1rem;
  margin: 0.5rem 0;
  word-wrap: break-word;
  word-break: normal;
}

.asset-name div {
  padding: 10px;
  border-bottom: 1px solid #666;
}

.asset-list {
  color: #666;
  margin: 15px 0;
  font-size: 18px;
  font-weight: 100;
  padding: 0 5px;
  border-left: 5px solid rgb(26 121 160);
  border-radius: 2px;
}

.asset-list.content {
  margin-top: 3rem;
}

.active {
  background-color: rgb(26 121 160);
  color: #ffffff;
}

.asset-list-A {
  margin-top: 20px;
  box-sizing: border-box;
  padding: 20px 10px 0;
}

.asset-list-A div {
  padding: 5px 0;
  color: #666;
}

.assets-main {
  color: #333;
  margin-left: 8px;
  border-left: 2px solid #ccc;
  padding-left: 15px;
  margin-top: 15px;
  background-color: #f6f6f6;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.assets-main.todo {
  border-color: #e15249;
}

.assets-main.done {
  border-color: #2db133;
}

.assets-main p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
  word-wrap: break-word;
  word-break: normal;
}

.assets-main p span {
  font-weight: 600;
}

.van-field__value {
  border-bottom: 1px solid #cdcdcd;
}

:deep(.highlight) {
  background-color: #ffeb3b !important;
}
</style>
